module.exports = __webpack_public_path__ + "img/72600.fbda658a.jpg";